import { Link, useParams } from 'react-router-dom'
import React from 'react'
import { useQuery } from 'react-query'
import fetch from 'isomorphic-fetch'

import { guessVars } from '../../actions/states/new/setupVars'

const FeatureBottom = () => {
  const params = useParams()
  const variableArray = guessVars(params.state)
  const qsParam = variableArray?.siteId ? `?regionId=${variableArray.siteId}` : ''
  const { data } = useQuery(['latest-webinars', qsParam], () => {
    return fetch(`/api/v2/marketing/webinars${qsParam}`, {
      method: 'GET'
    }).then(resp => resp.json())
  })
  const upcomingWebinar = data?.upcoming

  return (
    <div
      className="section feature-contact-section"
      style={{ paddingTop: '20px', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingBottom: '10px' }}>
        <div className="col-sm-4">
          <div className="title-wrap emailsignup">
            <h4>Have a Question?</h4>
            <p>
              Our team is here to answer your questions about the {variableArray.appName}
            </p>
          </div>
          <Link
            to={`${variableArray.pathPrefix}/quote`}
            className="btn btn-success btn-full">
            Ask Us
          </Link>
        </div>
        <div className="col-sm-4">
          <div className="title-wrap webinar">
            <h4>Watch our webinars</h4>
            <p>Sign-Up for our upcoming webinars, or watch previous recordings</p>
          </div>
          <Link
            to={
              upcomingWebinar?.webinarSignupForm
                ? `${variableArray.pathPrefix}/webinar`
                : `${variableArray.pathPrefix}/webinar/latest`
            }
            className="btn btn-success btn-full">
            {upcomingWebinar?.webinarSignupForm ? `Sign Up` : `Start Watching`}
          </Link>
        </div>
        <div className="col-sm-4">
          <div className="title-wrap brochure">
            <h4>Download brochure</h4>
            <p>
              Get our printable PDF to forward to a colleague or browse at a later date
            </p>
          </div>
          <a
            href={variableArray.brochureDownloadUrl || '#'}
            className="btn btn-success btn-full">
            Download
          </a>
        </div>
      </div>
    </div>
  )
}

export { FeatureBottom }
